import { LogoTypes } from './types';

export default function HeaderLogo({
  className,
  children,
}: LogoTypes): React.JSX.Element {
  return <div className={`header-logo ${className || ''}`}>{children}</div>;
}
